import { useState } from "react";
import { PrimaryButton } from "../../../components/Buttons";
import { colors } from "../../../components/colors";
import { DeliveryRulesModal } from "./DeliveryRulesModal";

type Props = {
  groupId?: string;
  color?: string;
  backgroundColor?: string;
  hoverColor?: string;
};

export const DeliveryRulesSelector = ({
  groupId,
  color,
  backgroundColor,
  hoverColor,
}: Props) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <div>
      <PrimaryButton
        color={color ?? colors.white}
        backgroundColor={backgroundColor ?? colors.ctaMain}
        hoverColor={hoverColor ?? colors.ctaSecondaryOne}
        onClick={() => setModalOpen(true)}
        type="button"
      >
        {groupId ? "Edit" : "Add new"}
      </PrimaryButton>
      <DeliveryRulesModal
        onClose={() => setModalOpen(false)}
        isOpen={modalOpen}
        ruleId={groupId}
      />
    </div>
  );
};
